import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseParamsService } from '@app/core/base-params.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';

const createLanguageParams = (language: string | undefined): string =>
  language ? `?hl=${language}` : '';

@Component({
  selector: 'app-recaptcha-info',
  imports: [
    TranslatePipe,
    NgClass,
  ],
  templateUrl: './recaptcha-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.tw-mb-spacing-300]': `isDs()`,
    class: 'tw-block',
  },
})
export class RecaptchaInfoComponent {
  public variant = input<'ds' | undefined>();
  public isDs = computed(() => this.variant() === 'ds');
  private language = toSignal(inject(BaseParamsService).language$);
  protected languageParam = computed(() => createLanguageParams(this.language()));
  protected linkClasses = computed(() => this.isDs() ? 'hover:tw-decoration-10 hover:tw-underline tw-cursor-pointer tw-text-component-link-primary tw-text-link-md' : '');
  protected textClasses = computed(() => this.isDs() ? 'tw-text-module-auth-text-header tw-text-body-regular-md' : '');
}
